import React from 'react';
import { Tab } from '@headlessui/react';
import { useResearchData } from '../../hooks/useResearchData';
import TableView from './TableView';
import MapView from './MapView';
import AnalyticsView from './AnalyticsView';
import SearchBar from './SearchBar';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Dashboard() {
    const { 
      data, 
      analyticsData, 
      loading, 
      error, 
      filters, 
      updateFilters 
    } = useResearchData();
  
    const tabs = [
      { name: 'Table View', component: TableView },
      { name: 'Map View', component: MapView },
      { name: 'Analytics', component: AnalyticsView }
    ];
  
    if (loading) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
        </div>
      );
    }
  
    if (error) {
      return (
        <div className="text-center text-red-600 p-4">
          Error loading data: {error}
        </div>
      );
    }
  
    return (
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">
          Drugs Research Network Scotland: Mapping of drugs research 2013-2023
        </h1>
  
        <SearchBar 
          filters={filters}
          onFilterChange={updateFilters}
        />
  
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-xl bg-blue-900/20 p-1">
            {tabs.map(tab => (
              <Tab
                key={tab.name}
                className={({ selected }) =>
                  classNames(
                    'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                    'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                    selected
                      ? 'bg-white shadow text-blue-700'
                      : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                  )
                }
              >
                {tab.name}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className="mt-2">
            {tabs.map(({ name, component: Component }) => (
              <Tab.Panel
                key={name}
                className={classNames(
                  'rounded-xl bg-white p-3',
                  'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
                )}
              >
                <Component data={data} analyticsData={analyticsData} />
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </Tab.Group>
      </div>
    );
  }